import PublicHeader from "@/components/public/PublicHeader";
import PublicFooter from "@/components/public/PublicFooter";

export default function MarketingLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#f5f7fb] text-slate-950">
      <div className="absolute inset-x-0 top-0 -z-10 h-[620px] bg-[radial-gradient(circle_at_top_left,_rgba(15,23,42,0.14),_transparent_34%),radial-gradient(circle_at_80%_10%,_rgba(14,165,233,0.18),_transparent_28%),linear-gradient(180deg,_#ffffff,_#f5f7fb_58%,_#eef3fa)]" />
      <PublicHeader />
      <main>{children}</main>
      <PublicFooter />
    </div>
  );
}
